(function () {
    window.addEventListener('load', function () {
        var BOOK_MARK = window.location.hash;
        var CURRENT_URL = window.location.href.split("#")[0];

        var FaqSpot = {
            classes: {
                FAQ_SPOT: ".faq-spot",
                FAQ_QUESTION: ".faq-question",
                POPUP_TRIGGER: ".open-modal-faq",
                POPUP_INPUT: ".modal-text-area",
                POPUP_BUTTON: ".modal-copy-btn"
            },
            openQuestionByBookmark: function () {
                var faqAccordion = document.querySelector(BOOK_MARK);

                if (faqAccordion) {
                    var currentfaqQuestion = document.querySelector(BOOK_MARK + ' ' + this.classes.FAQ_QUESTION);

                    if (currentfaqQuestion) {
                        currentfaqQuestion.click();
                    }
                }
            },
            setupEventListeners: function (faqSpot) {
                var linkSelectButtons = Array.prototype.slice.call(faqSpot.querySelectorAll(this.classes.POPUP_BUTTON));

                if (linkSelectButtons) {
                    linkSelectButtons.forEach(function (linkSelectButton) {
                        linkSelectButton.addEventListener('click', function (event) {
                            event.preventDefault();

                            var inputElement = linkSelectButton.previousElementSibling;

                            if (inputElement) {
                                inputElement.select();
                                document.execCommand("Copy");
                            }
                        });
                    });
                }

                var modalTriggers = Array.prototype.slice.call(faqSpot.querySelectorAll(this.classes.POPUP_TRIGGER));

                if (modalTriggers) {
                    modalTriggers.forEach(function (modalTriggerItem) {
                        modalTriggerItem.addEventListener('click', function () {
                            var popupContainer = modalTriggerItem.nextElementSibling;
                            var inputElement = '';
                            if (popupContainer) inputElement = popupContainer.querySelector(this.classes.POPUP_INPUT);

                            if (inputElement !== '' && inputElement !== undefined) {
                                var currentValue = inputElement.value;
                                inputElement.value = CURRENT_URL + currentValue;
                            }
                        }.bind(this));
                    }.bind(this));
                 }
            },
            init: function () {
                var faqSpots = document.querySelectorAll(this.classes.FAQ_SPOT);

                if (faqSpots.length > 0 && BOOK_MARK.replace('#', '').length > 0) {
                    this.openQuestionByBookmark();
                }

                Array.prototype.forEach.call(faqSpots, function (faqSpot) {
                    this.setupEventListeners(faqSpot);
                }.bind(this));
            }
        };

        /* Legacy code - needed to open accordion from button onclick */
        window.OpenFaq = function (faqId) {
            if (document.querySelector(".faq-spot")) {
                var questionNode = document.querySelector('.faq-question.' + CSS.escape(faqId));
                if (questionNode) questionNode.click();
            }
        }

        FaqSpot.init();
    }, false);
})();
